(function (app, ng) {

    app.controller("editPlanningEventController", editPlanningEventController);
    editPlanningEventController.$inject = ["$mdDialog", "marketingTrackerEventGroupApi", "marketingTrackerAncillaryEventGroupApi", "$timeout"];
    function editPlanningEventController($mdDialog, marketingTrackerEventGroupApi, marketingTrackerAncillaryEventGroupApi, $timeout) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    saving: false
                },
                stats: {},
                close: close,
                deleteEvent: deleteEvent,
                update: update,
                hasSaved: false,
                showSavedMessage: showSavedMessage
            });

        function close() {
            $mdDialog.hide({
                eventGroup: $ctrl.eventGroup,
                event: $ctrl.event
            });
        }

        function deleteEvent($event) {
            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to delete this event?",
                targetEvent: $event,
                ariaLabel: "Confirm event removal",
                ok: "Yes",
                cancel: "No",
                multiple: true,
                clickOutsideToClose: false
            });

            $mdDialog.show(confirm).then(function () {
                $ctrl.ui.deleting = true;
                if (!$ctrl.eventGroup.EventType.IsAncillary) {
                    return marketingTrackerEventGroupApi.deleteEvent($ctrl.eventGroup.Id, $ctrl.event.Id).then(function () {
                        $ctrl.ui.deleting = false;
                        return $mdDialog.hide({
                            eventGroupId: $ctrl.eventGroup.Id,
                            eventId: $ctrl.event.Id,
                            toDelete: true
                        });
                    });
                }
                return marketingTrackerAncillaryEventGroupApi.deleteAncillaryEvent($ctrl.eventGroup.Id, $ctrl.event.Id)
                    .then(function () {
                        $ctrl.ui.deleting = false;
                        return $mdDialog.hide({
                            eventGroupId: $ctrl.eventGroup.Id,
                            eventId: $ctrl.event.Id,
                            toDelete: true
                        });
                    });
            });
        }

        function showSavedMessage() {
            $ctrl.hasSaved = true;
            $timeout(function () {
                $ctrl.hasSaved = false;
            }, 3000);
        }

        function update() {
            $ctrl.ui.saving = true;

            if (!$ctrl.eventGroup.EventType.IsAncillary) {
                marketingTrackerEventGroupApi.update($ctrl.eventGroup.Id, $ctrl.eventGroup).then(function () {
                    marketingTrackerEventGroupApi.updateEvent($ctrl.eventGroup.Id, $ctrl.event.Id, $ctrl.event).then(function () {
                        $ctrl.ui.saving = false;
                        showSavedMessage();
                    });
                });
            } else {
                marketingTrackerAncillaryEventGroupApi.update($ctrl.eventGroup.Id, $ctrl.eventGroup).then(function () {
                    marketingTrackerAncillaryEventGroupApi.updateAncillaryEvent($ctrl.eventGroup.Id, $ctrl.event.Id, $ctrl.event).then(function () {
                        $ctrl.ui.saving = false;
                        showSavedMessage();
                    });
                });
            }
        }

        function init() {
            $ctrl.event.EventDate = new Date($ctrl.event.EventDate);
        }
        init();
    }

})(window.app, window.angular); //jshint ignore:line